



export const pipeDiaRating = [
    // { text: 'PC400', value: '400' },
    // { text: 'PC450', value: '450' },
    // { text: 'PC500', value: '500' },
    { text: 'PC600', value: '600' },
    // { text: 'PC650', value: '650' },
    { text: 'PC700', value: '700' },
    { text: 'PC750', value: '750' },
    { text: 'PC800', value: '800' },
    { text: 'PC900', value: '900' },
    // { text: 'PC1000', value: '1000' },
    { text: 'PC1050', value: '1050' },
    { text: 'PC1200', value: '1200' },
    { text: 'PC1400', value: '1400' },
    { text: 'PC1600', value: '1600' },
    { text: 'PC1800', value: '1800' },
    { text: 'PC2000', value: '2000' },
    { text: 'PC2200', value: '2200' },
    { text: 'PC2400', value: '2400' },
    { text: 'PC2600', value: '2600' },
    { text: 'PC2800', value: '2800' },
    { text: 'PC3000', value: '3000' },
];

export const library_pipe_conveyor = [
    {
        id: 1,
        beltWidth: 400,
        pipeDiameter: 100,
        area100: 0.00742,
        area75: 0.00562,
    },
    {
        id: 2,
        beltWidth: 450,
        pipeDiameter: 110,
        area100: 0.0095,
        area75: 0.00713,
    },
    {
        id: 3,
        beltWidth: 500,
        pipeDiameter: 120,
        area100: 0.0113,
        area75: 0.0085,
    },
    {
        id: 4,
        beltWidth: 600,
        beltMass: 9.0,
        beltThick: 7.4,
        pipeDiameter: 150,
        rotatingMassCarry: 19.8,
        rotatingMassReturn: 19.8,
        rollerDia: 89.1,
        panelPitchCarry: 1.0,
        panelPitchReturn: 2.0,
        area100: 0.0177,
        area75: 0.0133,
        overlapAngle: 75,
    },
    {
        id: 5,
        beltWidth: 650,
        pipeDiameter: 160,
        area100: 0.020,
        area75: 0.015,
    },
    {
        id: 6,
        beltWidth: 700,
        beltMass: 12.1,
        beltThick: 9.4,
        pipeDiameter: 188,              // 두 자료에 값이 다르게 되어 있음. 
        rotatingMassCarry: 21.6,
        rotatingMassReturn: 21.6,
        rollerDia: 89.1,
        panelPitchCarry: 1.0,
        panelPitchReturn: 2.0,
        area100: 0.0241,
        area75: 0.018,
        overlapAngle: 75,
    },
    {
        id: 7,
        beltWidth: 750,
        beltMass: 13.0,
        beltThick: 9.4,
        pipeDiameter: 190,
        rotatingMassCarry: 21.6,
        rotatingMassReturn: 21.6,
        rollerDia: 89.1,
        panelPitchCarry: 1.0,
        panelPitchReturn: 2.0,
        area100: 0.0284,
        area75: 0.0213,
        overlapAngle: 70,
    },
    {
        id: 8,
        beltWidth: 800,
        beltMass: 14.0,
        beltThick: 9.8,
        pipeDiameter: 215,          // 두 자료에 값이 다르게 되어 있음.
        rotatingMassCarry: 22.8,
        rotatingMassReturn: 22.8,
        rollerDia: 89.1,
        panelPitchCarry: 1.0,
        panelPitchReturn: 2.0,
        area100: 0.0333,
        area75: 0.0250,
        overlapAngle: 65,
    },
    {
        id: 9,
        beltWidth: 900,
        beltMass: 15.5,
        pipeDiameter: 235,
        rotatingMassCarry: 22.8,
        rotatingMassReturn: 22.8,
        rollerDia: 89.1,
        panelPitchCarry: 1.2,
        panelPitchReturn: 2.4,
        area100: 0.0434,
        area75: 0.0326,
        overlapAngle: 65,
    },
    {
        id: 10,
        beltWidth: 1000,
        pipeDiameter: 260,
        area100: 0.0541,
        area75: 0.0406,
    },
    {
        id: 11,
        beltWidth: 1050,
        beltMass: 23.0,
        beltThick: 10.3,
        pipeDiameter: 275,
        rotatingMassCarry: 25.2,
        rotatingMassReturn: 25.2,
        rollerDia: 89.1,
        panelPitchCarry: 1.2,
        panelPitchReturn: 2.4,
        area100: 0.0594,
        area75: 0.0446,
        overlapAngle: 60,
    },
    {
        id: 12,
        beltWidth: 1200,
        beltMass: 26.0,
        beltThick: 12.5,
        pipeDiameter: 315,
        rotatingMassCarry: 40.8,
        rotatingMassReturn: 40.8,
        rollerDia: 114.3,
        panelPitchCarry: 1.2,
        panelPitchReturn: 2.4,
        area100: 0.0779,
        area75: 0.0584,
        overlapAngle: 60,
    },
    {
        id: 13,
        beltWidth: 1400,
        beltMass: 33.0,
        beltThick: 14.0,
        pipeDiameter: 370,
        rotatingMassCarry: 40.8,
        rotatingMassReturn: 40.8,
        rollerDia: 114.3,
        panelPitchCarry: 1.2,
        panelPitchReturn: 2.4,
        area100: 0.1075,
        area75: 0.0806,
        overlapAngle: 60,
    },
    {
        id: 14,
        beltWidth: 1600,
        beltMass: 38.0,
        beltThick: 14.0,
        pipeDiameter: 420,
        rotatingMassCarry: 47.4,    // 47.4 -> 40.8 BW1400과 동일한 roller 114.3 사용
        rotatingMassReturn: 47.4,   // 47.4 -> 40.8 BW1400과 동일한 roller 114.3 사용
        rollerDia: 114.3,
        panelPitchCarry: 1.2,
        panelPitchReturn: 2.4,
        area100: 0.1385,
        area75: 0.1039,
        overlapAngle: 60,
    },
    {
        id: 15,
        beltWidth: 1800,
        beltMass: 46.0,
        beltThick: 14.8,
        pipeDiameter: 475,
        rotatingMassCarry: 42.6,
        rotatingMassReturn: 42.6,
        rollerDia: 139.8,
        panelPitchCarry: 1.2,
        panelPitchReturn: 2.4,
        area100: 0.1772,
        area75: 0.1329,
        overlapAngle: 60,
    },
    {
        id: 16,
        beltWidth: 2000,
        beltMass: 51.0,
        beltThick: 16.2,
        pipeDiameter: 530,
        rotatingMassCarry: 42.6,
        rotatingMassReturn: 42.6,
        rollerDia: 139.8,
        panelPitchCarry: 1.2,
        panelPitchReturn: 2.4,
        area100: 0.2206,
        area75: 0.1655,
        overlapAngle: 60,
    },
    {
        id: 17,
        beltWidth: 2200,
        beltMass: 56.0,
        beltThick: 16.2,
        pipeDiameter: 585,
        rotatingMassCarry: 47.4,
        rotatingMassReturn: 47.4,
        rollerDia: 139.8,
        panelPitchCarry: 1.2,
        panelPitchReturn: 2.4,
        area100: 0.2688,
        area75: 0.2016,
        overlapAngle: 60,
    },
    {
        id: 18,
        beltWidth: 2400,
        beltMass: 61.0,
        beltThick: 17.0,
        pipeDiameter: 640,
        rotatingMassCarry: 73.2,
        rotatingMassReturn: 73.2,
        rollerDia: 165.2,
        panelPitchCarry: 1.2,
        panelPitchReturn: 2.4,
        area100: 0.3217,
        area75: 0.2413,
        overlapAngle: 60,
    },
    {
        id: 19,
        beltWidth: 2600,
        beltMass: 66.0,
        beltThick: 17.0,
        pipeDiameter: 690,
        rotatingMassCarry: 73.2,
        rotatingMassReturn: 73.2,
        rollerDia: 165.2,
        panelPitchCarry: 1.2,
        panelPitchReturn: 2.4,
        area100: 0.3739,
        area75: 0.2804,
        overlapAngle: 60,
    },
    {
        id: 20,
        beltWidth: 2800,
        beltMass: 71.0,
        beltThick: 17.0,
        pipeDiameter: 745,
        rotatingMassCarry: 73.2,
        rotatingMassReturn: 73.2,
        rollerDia: 165.2,
        panelPitchCarry: 1.2,
        panelPitchReturn: 2.4,
        area100: 0.4359,
        area75: 0.3269,
        overlapAngle: 60,
    },
    {
        id: 21,
        beltWidth: 3000,
        beltMass: 76.0,
        beltThick: 17.0,
        pipeDiameter: 800,
        rotatingMassCarry: 82.8,
        rotatingMassReturn: 82.8,
        rollerDia: 165.2,
        panelPitchCarry: 1.2,
        panelPitchReturn: 2.4,
        area100: 0.5027,
        area75: 0.3770,
        overlapAngle: 60,
    },
]

export const getDiaRelatedValue = (pipeDia, propertyName) => {
    const item = library_pipe_conveyor.find((obj) => obj.pipeDiameter === parseInt(pipeDia));
    if (!item) {
        return undefined;
    }
    return item[propertyName];
}

